<template>
	<div class="c-s z-ant-input" v-if="isShow" style="position: fixed;top: 0;height: 100vh;z-index: 999;">
		<div :show="isShow" @click="_click(false) " style="position: initial;background-color: rgba(0, 0, 0, 0.7);height: 100%;width: var(--theme-max-width);" z-index="4" >
			 <div class="wrapper" >
				<div style="">
					<div class="ant-modal-content" @click.stop>
							<div class="ant-modal-header"><div id="rcDialogTitle1" class="ant-modal-title">Add Account</div></div>
							<div class="ant-modal-body">
								<div class="gD0G2pAAJZZTJ1n0KQXv" >
									<!-- margin-bottom: .5rem; -->
									<antInput  :clearable='false' @onInput="_onInput" :modelValue="forData.account_name" form-key='account_name'
										:placeholder="$t('components._Introduzaoseunomereal')">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg-icon className="prefix"
												icon-class="input_icon_zsxm--svgSprite:all" />
										</div>
									</antInput>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antS @_click="chooseType" :dados="['UPI',]" :modelvalue="accountType">
										<div slot="left-icon"
										style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;"
										>
										<svg style="width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
											<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
											<path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
										</svg>
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv" v-if="isUPI">
									<antS @_click="chooseBank" :dados="bankList" :modelvalue="nowBank" fontSizeClass="spanfontsize18">
										<div slot="left-icon" style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;" >
										<svg-icon className="prefix" icon-class="input_icon_bank--svgSprite:all" />
										</div>
									</antS>
									<antInput v-if="0" :clearable='false' @onInput="_onInput" :modelValue="forData.account_pix" form-key='account_pix'
										placeholder="Introduza a sua chave do PIX">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg-icon className="prefix" icon-class="input_icon_bank--svgSprite:all" />
										</div>
									</antInput>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antInput maxlength="50" :modelValue="forData.account_cpf" @onInput="_onInput" :clearable='false' form-key='account_cpf'
										placeholder="Enter your account No.">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg style="vertical-align: -0.15em;width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
												<path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-1 2c0 .17-.014.337-.04.5H2a1 1 0 0 1-.984-.819C1.2 10.398 2.914 9 5 9c2.21 0 4 1.567 4 3.5ZM7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
											</svg>
										</div>
									</antInput>
								</div>
								<div class="Kw58s_FCuipHRV_EW4tG">
									<span>{{ $t('withdraw._Verifique') }} </span>
								</div>
								<div class="Pt3rGlTmq0_WLpTGHsA_" @click="setBank">
									<van-button class="JHBAn8W0jkHI1OM_X2fy" type="primary">{{ $t('withdraw._Confirmar') }}</van-button>
								</div>
							</div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		setBank
	} from "@/apis/modules/login.js"
	import antInput from "./input.vue"
	import antInputPassword from "@/components/ant-input-password/index.vue"
	import antS from "./ant-s.vue"
	import { Toast } from 'vant';
	export default{
		components:{
			antInputPassword,
			antInput,
			antS
		},
		props:{
			isShow:{
				type:Boolean,
				default: false,
			},
			formDta:{
				type:[Object],
				default:()=>{return {}},
				
			}
			
		},
		data() {
			return{
				show:true,
				isShowNum:false,
				shuruKOangName:'',
				accountType:0,
				nowBank:0,
				isUPI:false,
				forData:{
					account_name:'',
					account_pix:'',
					account_cpf:'',
					account_type:'UPI',
				},
				bankList : [
					'Please select a bank',
					'AU Small Finance Bank (ASF)','Aditya Birla Payments Bank (ABP)','Airtel Payments Bank (AP)','Allahabad Bank (ALLA)','Andhra Bank (ANDH)',
					'Andhra Pradesh Grameena Vikas Bank (APGV)','Andhra Pragathi Grameena Bank (APG)','Arunachal Pradesh Rural Bank (APR)','Aryavart Bank (ARYA)',
					'Assam Gramin Vikash Bank (AGV)','Axis Bank (AXIS)','BANK OF BAHRAIN AND KUWAIT (BOBAK)','BHARAT BANK (BHARAT)','Bandhan Bank (BANDHAN)',
					'Bangiya Gramin Vikash Bank (BGV)','Bank DBS Indonesia (DBS)','Bank of Baroda (BOB)','Bank of India (BOI)','Bank of Maharashtra (BOM)',
					'Baroda Gujarat Gramin Bank (BGG)','Baroda Rajasthan Kshetriya Gramin Bank (BRKG)','Baroda Uttar Pradesh Gramin Bank (BUPG)',
					'Bassein Catholic Co-operative Bank (BCCO)','CAPITAL SMALL FINANCE BANK LTD (CSFB)','COSMOS BANK (COSMOS)','CSB Bank (CSB)','Canara Bank (CANARA)',
					'Catholic Syrian Bank (CASY)','Central Bank of India (CBOI)','Chaitanya Godavari Grameena Bank (CGG)','Chhattisgarh Rajya Gramin Bank (CRG)',
					'Citi bank (CITI)','City Union Bank (CU)','Coastal Local Area Bank Limited (CLA)','Corporation Bank (CORP)','DCB Bank (DCB)',
					'DEVELOPMENT BANK OF SINGAPORE (DBOS)','DNLM (DNLM)','Dakshin Bihar Gramin Bank (DBG)','Dena Bank (DENA)','Deutsche Bank AG (DBAG)',
					'Dhanlaxmi Bank (DHAN)','ESAF Small Finance Bank (ESAF)','Ellaquai Dehati Bank (ELD)','Equitas Small Finance Bank (ESF)','Equitas bank (EQUITAS)',
					'Exim Bank (EXIM)','FINO PAYMENT BANK (FIP)','Federal Bank (FEDERAL)','Fincare Small Finance Bank (FSF)','GOPINATH PATIL PARSIK JANATA SSAHAKARI (GPPJS)',
					'HDFC Bank (HDFC)','HSBC Bank (HSBC)','Himachal Pradesh Gramin Bank (HPG)','ICICI Bank (ICICI)','ICICI corporate Bank (ICICIC)','IDBI Bank (IDBI)','IDFC First Bank (IDFC)',
					'India Post Payments Bank (IPP)','Indian Bank (IND)','Indian Overseas Bank (INDOV)','IndusInd Bank (INDUSIND)','J&K Grameen Bank (JKG)',
					'JANATA SAHAKARI BANK LTD PUNE (JANATA)','Jammu and Kashmir Bank (JAK)','Jana Small Finance Bank (JSF)','Jharkhand Rajya Gramin Bank (JRG)',
					'Jio Payments Bank (JIO)','Karnataka Bank (KARNATAKA)','Karnataka Gramin Bank (KG)','Karnataka Vikas Grameena Bank (KVG)','Karur Vysya Bank (KV)',
					'Kashi Gomti Samyut Gramin Bank (KGSG)','Kerala Gramin Bank (KEG)','Kotak Mahindra Bank (KM)','Lakshmi Vilas Bank (LV)','Lndus Ind Bank (LIND)',
					'MADHYA BIHAR GRAMIN BANK (MBG)','MEGHALAYA RURAL BANK (MR)','Madhya Pradesh Gramin Bank (MPG)','Madhyanchal Gramin Bank (MADG)',
					'Maharashtra Gramin Bank (MAHG)','Manipur Rural Bank (MANIPURR)','Mizoram Rural Bank (MIZORAMR)','NHB (NHB)','NSDL Payments Bank (NSDL)',
					'Nagaland Rural Bank (NAGALANDR)','Nainital Bank (NAINITAL)','National Bankfor Agricultureand Rural D (NBARD)','North East Small Finance Bank (NESF)',
					'Odisha Gramya Bank (OG)','Oriental Bank of Commerce (OBOC)','PAYTM PAYMENTS BANK (PAYTM)','PUNJAB GRAMIN BANK (PUNJAB)','Paschim Banga Gramin Bank (PBG)',
					'Pragathi Krishna Gramin Bank (PKG)','Pragati Krushna Gramina Bank (PKGB)','Prathama UP Gramin Bank (PUPG)','Puduvai Bharathiar Grama Bank (PBGB)',
					'Punjab National Bank (PUNNA)','Punjab and Sind Bank (PAS)','Purvanchal Bank (PURVAN)','RBL BANK LTD (RBL)','ROYAL BANK OF SCOTLAND (RBOS)',
					'Rajasthan Marudhara Gramin Bank (RMG)','Reserve Bank of India (RBOI)','Saraswat Bank (SARASWAT)','STANDARD CHARTERED BANK T P (SCBTP)','SVC COOPERATIVE BANK LTD (SCBL)',
					'Saptagiri Grameena Bank (SG)','Sarva Haryana Gramin Bank (SHG)','Saurashtra Gramin Bank (SGB)','Small Industries Development Bankof India (SIDBI)',
					'South Indian Bank (SIB)','Standard Chartered Bank (SCB)','State Bank of Hyderabad (SBOH)','State Bank of India (SBOI)','Subhadra Local Area Bank Ltd (SLA)',
					'Suco Souharda Sahakari Bank (SSS)','Suryoday Small Finance Bank Ltd (SSFB)','Syndicate Bank (SYNDICATE)','Telangana grameena Bank (TELG)','Tamil Nadu Grama Bank (TNG)',
					'Tamilnad Mercantile Bank Limited (TMB)','Tripura Gramin Bank (TG)','UCO Bank (UCO)','UTTAR BIHAR GRAMIN BANK (UBG)','Ujjivan Small Finance Bank (USF)',
					'Uko Bank (UKO)','Union Bank of India (UBOI)','United Bank of India (UNITEDBOI)','Utkal Grameen Bank (UG)','Utkarsh Small Finance Bank (UTKSF)',
					'Uttar Banga Kshetriya Gramin Bank (UBKG)','Uttarakhand Gramin Bank (UTTG)','Vananchal Gramin Bank (VANG)','Vidharbha Konkan Gramin Bank (VKG)',
					'Vijaya Bank (VIJAYA)','Yes Bank (YES)',
				],
			}
		},
		watch: {
		    // 当message变化时，这个函数就会被调用
		    isShow(newValue, oldValue) {
				this.forData = this.formDta.account_type ? {...this.formDta} : {account_name:'',account_pix:'',account_cpf:'',account_type:'UPI',};
				if(this.forData.account_type){
					this.accountType=['UPI',].indexOf(this.forData.account_type);
					if(this.accountType==-1){
						this.accountType=0;
					}
				}
				this.isUPI=false;
				this.nowBank = 0;
				if(this.forData.account_type=='UPI'){
					this.isUPI=true;
					this.nowBank=this.forData.account_pix || 0;
				}
				
		  //     console.log(this.forData,newValue);
		      // 这里可以添加更多响应数据变化的逻辑
		    }
		  },
		methods:{
			_click(){
				this.$emit('_click',false)
			},
			chooseType(item,index){
				this.accountType=index;
				this.forData.account_type=item;
				this.isUPI=false;
				if(item=='UPI'){
					this.isUPI=true;
				}
			},
			chooseBank(item,index){
				this.nowBank=index;
				this.forData.account_pix=index;
			},
			_onInput(v,k){
				this.forData[k]=v;
			},
			setBank(){
				let msg = '';
				if(!this.forData.account_name)msg = this.$t('_homeTile_tab._campodeNomereal');
				if(!msg && this.accountType > 0 && this.forData.account_pix < 1){msg = 'Please select a bank'}
				if(!msg && (!this.forData.account_cpf || this.forData.account_cpf.length < 11)){msg = 'Enter the correct account No.'}
				if(msg){
					Toast.fail({
						message:this.myLineBreaks(msg),
						duration:0
					});
					setTimeout(()=>{
						Toast.clear()
					},1000)
					return false;
				}

				setBank({...this.forData}).then(({code,msg,data})=>{
					if(code==0){
						Toast.success({
							message:this.myLineBreaks(msg),
							duration:1000
						});
						setTimeout(()=>{
							location.reload();
							this.$attrs.getBank();
							this.$emit('onIsShow',false)
						},1500)
						return false;
					}
					Toast.loading({
						message:this.myLineBreaks(msg),
						duration:1000
					});
				})
			}
		}
	}
</script>
<style>
/* 	.c-s{
		width: 100%;
		height: 100vh;
	} */
	.c-s{
		width: 100vw;
	}
	.c-s .van-overlay{
		width: 100vw;
		/* position: absolute;
		    background-color: rgba(0, 0, 0, .45); */
	}
	.van-field__body input{
		font-size: 0.27rem;
	}
</style>
<style scoped>
	
	.wrapper{
		 display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	 .ant-modal-content {
	    background-color: var(--theme-main-bg-color);
	    border-width: thin;
	    border-style: solid;
	    border-image: initial;
		box-sizing: border-box;
		width: 6.9rem;
	    border-color: var(--theme-color-line);
	    border-radius: 0.2rem;
	    max-height: calc(var(--vh, 1vh)*100 - .1rem);
	    overflow: auto;
	    position: static;
		margin: 0 auto;
	}
	.gD0G2pAAJZZTJ1n0KQXv{
		margin-bottom: .5rem;
	}
	.ant-modal-header{
		 background-color: var(--theme-main-bg-color);
		    border-bottom: none;
		    border-radius: .2rem .2rem 0 0;
		    padding: .2rem .3rem
	}
	.ant-modal-title{
			color: var(--theme-text-color-darken);
		    font-size: .24rem;
		    font-weight: revert;
		    line-height: .34rem;
		    text-align: center;
	}
	.Ou1aviPriFX421w97dGA{
		display: flex;
		align-items: center;
		justify-content: space-between;
		    margin-bottom: .15rem;
		    font-size: .22rem;
			    color: var(--theme-text-color-darken);
	}
	.Ou1aviPriFX421w97dGA .ZaAWGnvFuhPwlBk40od_{
		font-size: .36rem;
		width: .36rem;
		height: .36rem;
		    color: var(--theme-text-color-lighten);
	}
	.Ou1aviPriFX421w97dGA .isShowNum .ZaAWGnvFuhPwlBk40od_{
		color: var(--theme-primary-color);
	}
	.ant-modal-body{
		    padding-top: .2rem !important;
		    padding: .3rem;
	}
	.Kw58s_FCuipHRV_EW4tG{
		    color: var(--theme-text-color-darken);
		    font-size: .22rem;
			display: flex;
	}
	._7B8oTwzAn2VmdNYw3F0z {
	    color: var(--theme-primary-color);
	    cursor: pointer;
	    text-align: right;
	}
	.closeIcon{
		
	}
	.QzRd3YqTnYxG8Latq8fW {
	    background: none;
	    height: .64rem;
	    width: .64rem;
		margin: 0 auto;
	}
	.QzRd3YqTnYxG8Latq8fW img{
		width: 100%;
		height: 100%;
	}
	.JHBAn8W0jkHI1OM_X2fy {
	    border-radius: .14rem;
	    font-size: .24rem;
		width: 100%;
	    height: .7rem;
		 background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
	    line-height: .7rem;
	}
</style>